export class Expense {
  expenseId: string;
  businessId: string;
  createdAt: number;
  description?: string;
  amount: number;
  type: string;
  site: string;
  account: string;
  status: string;
  date: string;
  vatAmount?: number;
  vatType: string;
  refNo?: string;
  payee?: string;
  voucher?: string;
  chequeNo?: string;
  createdBy: string;
  reviewedBy?: string;
  approvedBy?: string;
  doneBy?: string;
}

export enum ExpenseStatus {
  OPEN = 'Open',
  APPROVED = 'Approved',
  REVIEWED = 'Reviewed',
  DONE = 'Done',
}
